import SearchTypeSelectorContainer from 'components/SearchTypeSelector/SearchTypeSelectorContainer'

export default {
  Container: SearchTypeSelectorContainer,
}
